import { config } from '../config';
import { combineUrl, isJsonResponse } from '../utilities/utilities';
export class HttpClient {
    constructor(baseUrl, accessTokenFactory, clientComponent) {
        this.baseUrl = baseUrl;
        this.accessTokenFactory = accessTokenFactory;
        this.clientComponent = clientComponent;
    }
    async get(url) {
        const requestInit = {
            method: 'GET',
            headers: await this.getRequestHeaders()
        };
        return await this.send(url, requestInit);
    }
    async post(url, body) {
        const requestInit = {
            method: 'POST',
            body: body ? JSON.stringify(body) : null,
            headers: await this.getRequestHeaders()
        };
        return await this.send(url, requestInit);
    }
    async send(relativeUri, init) {
        const response = await fetch(combineUrl(this.baseUrl, relativeUri), init);
        return await this.handleResponse(response);
    }
    async getRequestHeaders() {
        const requestHeaders = new Headers();
        requestHeaders.set('Content-Type', 'application/json');
        requestHeaders.set('X-Client-Version', `JavaScript/${config.version}`);
        requestHeaders.set('X-Client-Component', this.clientComponent);
        const jwt = await this.accessTokenFactory();
        if (jwt) {
            requestHeaders.set('Authorization', `Bearer ${jwt}`);
        }
        return requestHeaders;
    }
    async handleResponse(response) {
        if (!response.ok) {
            throw response;
        }
        return isJsonResponse(response) ? await response.json() : await response.text();
    }
}
